import { VERDICT_LABEL, type BackendVerdict } from '../components/VerdictSeal'

/**
 * Share message contract — keep in sync with the mobile copy in
 * apps/mobile/src/utils/shareText.ts. URL on its own line so messaging
 * apps unfurl it; the claim itself never goes in the message body.
 */
export function shareText(headline: string | undefined, verdict: BackendVerdict | undefined, url: string): string {
  const summary = headline ?? (verdict ? VERDICT_LABEL[verdict] : 'See the verdict')
  return `Verified with Treu: ${summary}\n${url}`
}
